import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Menu } from 'antd';
import { withRouter, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import sideMenus from '@/constants/side-menus';
import { DICT_IGNORE_PATH } from '@/constants';
import { getAllowedMenus, getAllowedMenusByCode } from '@/store/allowed-menus';
import { isChildPath } from '@/common/utils/path/index';
import { filterDisabledRoutes, getLinkByPath } from '@/store/menus.utils';
import useSlideMenuCollapsedChange from '@/hooks/useSlideMenuCollapsedChange';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import redirectDetailToActivityList from './redirect-actived-menu';
import classnames from 'classnames';
import utils, { getQuery } from '@/common/utils';
import ComponentLog from '@/components/component-log';
import { connect } from 'react-redux';
import { getGlobalGuideList } from '@/store/auto-guide';
import AutoGuide from '@/components/auto-guide';
import { useHistory } from 'react-router-dom';
import { matchPath } from 'react-router-dom';
import apis from '@/apis';
import './index.less';

const { SubMenu } = Menu;

const subMenuItemStyle = {
  paddingLeft: '8px',
};

// {[完整的pathname]: true}
function parseSideMenus(menus) {
  const res = {};
  if (!menus || !menus.length) return res;

  _cache(menus);

  return res;

  function _cache(menus, parentPath = '') {
    menus.forEach((item) => {
      const _parentPath = parentPath || '';

      res[_parentPath + item.path] = true;

      if (item.menus && item.menus.length) _cache(item.menus, _parentPath + item.path);
    });
  }
}

function findActivedPathInSideMenus(parentPathname, childPathname, prevFinded) {
  if (!parentPathname) return false;

  if (parentPathname === '\\/' || parentPathname === '/') {
    if (childPathname === '/') return parentPathname;
    // /404 /no-power等页面不应该高亮首页
    else return prevFinded;
  }

  if (!isChildPath(parentPathname, childPathname)) return prevFinded;

  if (parentPathname.length >= prevFinded.length) return parentPathname;

  return prevFinded;
}

// 过滤掉 {menuId: 1, menus: []} 这样的，没有文件的文件夹不用展示
function filterEmptySubmenu(sideMenus = []) {
  return sideMenus.filter((item) => !item.menus || item.menus.length !== 0);
}

function SlideMenu(props) {
  const history = useHistory();
  const [hints, setHints] = useState([]);
  const [selectedKeys, setSelectKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState(['/all-about-me', '/product-manager']); //默认展开待办事项
  const [selectedSubMenu, setSelectedSubMenu] = useState(''); //当前选中subMenu, 默认展开待办事项
  const globalGuideList = useRef(props.getGlobalGuideList);
  const guideShowList = props.list.length > 0 ? props.list.map((item) => item.location.split('-').slice(-1)[0]) : [];
  const menus = useSelector((state) => {
    return state.menus.filter((item) => !DICT_IGNORE_PATH[item.path]);
  });
  const [outestSideMenuClasename, _, toggleSidemenuCollapsedSatus] = useSlideMenuCollapsedChange(
    'outest-side-menu-collapsed',
    'outest-side-menu-uncollapsed'
  );

  const parsedSideMenus = useMemo(() => {
    return parseSideMenus(sideMenus);
  }, []);

  useEffect(() => {
    globalGuideList.current();
  }, []);

  /* eslint-disable */
  useEffect(() => {
    let hints = [];
    if (props.list.length > 0) {
      props.list.forEach((item, index) => {
        if (
          item.type == 2 &&
          item.location.split('-').length <= 1 &&
          outestSideMenuClasename == 'outest-side-menu-uncollapsed'
        ) {
          const element = document.querySelector(`li[data-new='id-${guideShowList[index]}']`);
          if (element !== null) {
            hints.push({
              title: item.title,
              element,
              intro: item.content,
              menuId: guideShowList[index],
              button: item.button,
              direction: 'left',
            });
          }
        }

        if (item.type == 2 && item.location.split('-').length > 1) {
          setTimeout(() => {
            if (
              document.querySelector(`li[data-new='id-${item.location.split('-')[0]}']`) !== null &&
              document
                .querySelector(`li[data-new='id-${item.location.split('-')[0]}']`)
                .classList?.contains('ant-acore-menu-submenu-open')
            ) {
              hints.push({
                title: item.title,
                element: document.querySelector(`li[data-new='id-${guideShowList[index]}']`),
                intro: item.content,
                menuId: guideShowList[index],
                button: item.button,
                direction: 'left',
              });
              setHints(Object.assign([], hints));
            }
          }, 500);
        }
      });

      setHints(Object.assign([], hints));
    } else {
      setHints([]);
    }
  }, [props.list, outestSideMenuClasename]);
  /* eslint-enable */

  useEffect(() => {
    let prevPathname = '';

    Object.keys(parsedSideMenus).some((parentPathname) => {
      if (prevPathname.length > parentPathname.length || prevPathname === '/' /* /是严格匹配 */) return true;
      prevPathname = findActivedPathInSideMenus(parentPathname, props.location.pathname, prevPathname);
    });
    setSelectKeys([redirectDetailToActivityList(prevPathname, props.location.pathname)]);
  }, [props.location.pathname, parsedSideMenus]);

  const _sideMenus = useMemo(() => {
    return filterEmptySubmenu(filterDisabledRoutes(sideMenus, getAllowedMenus(), getAllowedMenusByCode(), false));
    // eslint-disable-next-line
  }, [menus]);

  //根据路由找到最匹配的subMenu，然后展开他
  function findOpenSubMenuKey(pathName) {
    const getSubMenus = _sideMenus.filter((ele) => !!ele.menus);
    let getOpenKeys = [];
    getSubMenus.map((item) => {
      let match = matchPath(pathName, { path: item.path, exact: false, strict: false });
      if (match) getOpenKeys.push(item.path);
    });
    if (getOpenKeys.length >= 2) {
      getOpenKeys.sort((a, b) => b.length - a.length);
      getOpenKeys = [getOpenKeys[0]];
    }
    return getOpenKeys;
  }

  useEffect(() => {
    const _openKeys = findOpenSubMenuKey(props.location.pathname);
    if (!_openKeys.length || selectedSubMenu == _openKeys[0]) return;
    setSelectedSubMenu(_openKeys[0]);
    setOpenKeys((openKeys) => openKeys.concat(_openKeys));
    // eslint-disable-next-line
  }, [props.location.pathname]);

  function iSeeIt(menuId) {
    let currIndex = '';
    guideShowList.forEach((item, index) => {
      if (item == menuId) {
        currIndex = index;
      }
    });
    apis
      .functionGuideGuide({ location: props.list[currIndex].location })
      .then((res) => {
        if (res && res.ret === '0') {
          globalGuideList.current();
          const ele = document.querySelector(`li[data-new='id-${guideShowList[currIndex]}']`);
          history.push(ele.dataset.guide);
        } else {
          message.error(res.msg);
        }
      })
      .catch((err) => {
        message.error(err);
      });
  }

  const outestSideClassnames = classnames('outest-side outest-side-menu', outestSideMenuClasename);

  /**
   * 渲染侧边栏链接
   *
   * @param {{
   *  path: string
   *  title: string
   *  target: _blank | undefined 是否新开tab
   * }} menuConfigItem
   * @param {*} parentMenuConfigItem
   */
  function renderLink(menuConfigItem, parentMenuConfigItem) {
    const parentPath = parentMenuConfigItem ? parentMenuConfigItem.path : '';
    const { getlog } = menuConfigItem;
    const clstag = typeof getlog === 'function' ? getlog() : null;

    const path = getLinkByPath(menuConfigItem.getLink, {
      search: '',
      relativePath: menuConfigItem.path,
      parentPath,
      path: parentPath + menuConfigItem.path,
    });

    const indentStyle = parentMenuConfigItem ? subMenuItemStyle : undefined;

    if (menuConfigItem.target === '_blank') {
      return (
        <ComponentLog>
          <a
            clstag={clstag}
            target="_blank"
            rel="noopener noreferrer"
            style={indentStyle}
            onClick={() => hrefAndGetNewIcon(menuConfigItem.menuId, 'href', path)}
            // href={path}
            className="sub-menu-item-link"
          >
            {menuConfigItem.title}
            {renderIcon(menuConfigItem)}
          </a>
        </ComponentLog>
      );
    } else {
      return (
        <ComponentLog>
          <Link
            style={indentStyle}
            to={path}
            clstag={clstag}
            onClick={() => hrefAndGetNewIcon(menuConfigItem.menuId, 'to')}
            className="sub-menu-item-link"
          >
            {menuConfigItem.title}
            {renderIcon(menuConfigItem)}
          </Link>
        </ComponentLog>
      );
    }
  }

  function hrefAndGetNewIcon(menuId, type, path) {
    if (type == 'href') {
      if (path) {
        window.open(path);
      }
    } else {
      if (path) {
        history.push(path);
      }
    }
    needClickNewTag(menuId);
  }

  function renderIcon(item, addClass) {
    let currIdFlag = '';
    let url = '';
    const matchList = props.list.filter((obj) => obj.location.split('-').slice(-1)[0] == item.menuId);
    if (matchList && matchList.length) {
      const matchItem = matchList[0];
      if (matchItem.type == 1) {
        currIdFlag = 'FUNC';
        url = '//img30.360buyimg.com/pop/jfs/t1/150315/19/21909/1858/620dfc9cEb4a7628d/6fa98dcaab6ce312.png';
      }
      if (matchItem.type == 3) {
        currIdFlag = 'FUNC';
        url = matchItem.imageUrl;
      }
    }
    // props.list.forEach((obj) => {
    //   if (obj.location.split('-').slice(-1)[0] == item.menuId) {
    //     if (obj.type == 1) {
    //       currIdFlag = 'FUNC';
    //       url = '//img30.360buyimg.com/pop/jfs/t1/150315/19/21909/1858/620dfc9cEb4a7628d/6fa98dcaab6ce312.png';
    //     }
    //     if (obj.type == 3) {
    //       currIdFlag = 'FUNC';
    //       url = obj.imgUrl;
    //     }
    //   }
    //   if (obj.type == 1 && obj.location.split('-').slice(-1)[0] == item.menuId) {
    //     currIdFlag = 'FUNC';
    //   }
    // });
    if (currIdFlag === 'FUNC') {
      return (
        <img
          src={url}
          className={classnames('sub-menu-item-icon', addClass, {
            'nav-sec-item-title-icon-custom': matchList[0].type == 3,
          })}
        />
      );
    }
  }

  function needClickNewTag(menuId) {
    let currIdFlag = '';
    props.list.forEach((obj) => {
      if (obj.type == 1 && obj.location.split('-').slice(-1)[0] == menuId) {
        currIdFlag = 'FUNC';
      }
    });
    if (currIdFlag === 'FUNC') {
      iSeeIt(menuId);
    }
  }

  function onTitleClick(a, menuId) {
    needClickNewTag(menuId);

    let childrensMenus = [];
    a.forEach((item) => {
      childrensMenus.push(String(item.menuId));
    });

    if (props.list.length > 0) {
      props.list.forEach((item, index) => {
        if (
          item.type == 2 &&
          item.location.split('-').length > 1 &&
          childrensMenus.indexOf(guideShowList[index]) !== -1 &&
          document
            .querySelector(`li[data-new='id-${item.location.split('-')[0]}']`)
            ?.classList?.contains('ant-acore-menu-submenu-open') === false
        ) {
          setTimeout(() => {
            hints.push({
              title: item.title,
              element: document.querySelector(`li[data-new='id-${guideShowList[index]}']`),
              intro: item.content,
              menuId: guideShowList[index],
              button: item.button,
              direction: 'left',
            });
            setHints(Object.assign([], hints));
          }, 500);
        }
      });
    }
  }

  function getRealPath(menuConfigItem, parentMenuConfigItem) {
    const parentPath = parentMenuConfigItem ? parentMenuConfigItem.path : '';
    const path = getLinkByPath(menuConfigItem.getLink, {
      search: '',
      relativePath: menuConfigItem.path,
      parentPath,
      path: parentPath + menuConfigItem.path,
    });
    return path;
  }
  // 嵌入营销阵地
  if (getQuery('origin') === 'Babel') {
    return null;
  }

  return (
    <div className={outestSideClassnames}>
      {/* <SideMenuHeader /> */}
      <Menu
        id="side-bar-scroll"
        className="hidden-scroll-bar"
        inlineIndent={11}
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        mode="inline"
        theme="light"
        onOpenChange={(openKeys) => setOpenKeys(openKeys)}
      >
        {_sideMenus.map((item) => {
          const iconsProps = item.Icon ? { icon: <item.Icon /> } : {};
          const { getlog } = item;
          const clstag = typeof getlog === 'function' ? getlog() : null;
          if (item.menus) {
            return (
              <SubMenu
                onTitleClick={() => onTitleClick(item.menus, item.menuId)}
                data-guide={getRealPath(item)}
                data-new={`id-${item.menuId}`}
                popupClassName="outest-side-submenu"
                {...iconsProps}
                key={item.path}
                title={
                  <ComponentLog>
                    <span clstag={clstag} className="sub-menu-item-link">
                      {item.title}
                      {renderIcon(item, 'first-level')}
                    </span>
                  </ComponentLog>
                }
              >
                {item.menus.map((childItem) => (
                  <Menu.Item
                    clstag={clstag}
                    data-new={`id-${childItem.menuId}`}
                    data-guide={getRealPath(childItem, item)}
                    key={item.path + childItem.path}
                  >
                    <span className="sub-menu-item">{renderLink(childItem, item)}</span>
                  </Menu.Item>
                ))}
              </SubMenu>
            );
          } else {
            return (
              <Menu.Item data-new={`id-${item.menuId}`} data-guide={getRealPath(item)} {...iconsProps} key={item.path}>
                {renderLink(item)}
              </Menu.Item>
            );
          }
        })}
      </Menu>
      {/* <SideMenuFooter /> */}
      <div className="btn-collapsed-l">
        <div className="btn-collapsed-close" onClick={toggleSidemenuCollapsedSatus}>
          <LeftOutlined />
        </div>
      </div>
      <div className="btn-collapsed-r">
        <div className="btn-collapsed-open" onClick={toggleSidemenuCollapsedSatus}>
          <img
            style={{ width: '18px' }}
            src={utils.resizeImg(
              '//img30.360buyimg.com/pop/jfs/t1/173926/17/25119/1588/61d933b4E392b5ce7/a4d9013c378a83b9.png',
              60
            )}
          />
          <RightOutlined />
        </div>
      </div>
      {hints.length > 0 && <AutoGuide hints={hints} iSeeIt={iSeeIt} />}
    </div>
  );
}

const _SlideMenu = connect(
  (state) => {
    return {
      list: state.globalGuide.list,
    };
  },
  { getGlobalGuideList }
)(SlideMenu);

export default withRouter(_SlideMenu);
